import type { OrgDTO } from '@bb/domain/dist/types/dto/UserController/org';

export enum TabKeyType {
  Client = 'client',
  Supplier = 'supplier',
  Brokerage = 'brokerage',
}

type UnwrapArray<T> = T extends (infer R)[] ? R : T;

export type BrokerageUser = UnwrapArray<OrgDTO['users']>;
